import script from "./UserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/UserCard.css?vue&type=style&index=0&id=3ab4125f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab4125f"]])

export default __exports__